import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { WineClubDataStore } from '../wine-club-data';
import { IWineClubSignupConfig, IWineClubSignupResources } from '../wine-club-signup.props.autogenerated';

export interface IMembership {
    config: IWineClubSignupConfig;
    resources: IWineClubSignupResources;
}

enum MEMBER_TYPES {
    SELF,
    GIFT
}

/**
 * declaration of the membership type selector for the order
 */
export class Membership extends React.Component<IMembership> {

    private _dataStore: WineClubDataStore;

    constructor(props: IMembership) {
        super(props);

        this._onMemberTypeSelect = this._onMemberTypeSelect.bind(this);

        this._dataStore = WineClubDataStore.getInstance();
    }

    public render(): JSX.Element {
        const {
            wineClubSignup__stepThreeMembership,
            wineClubSignup__clubMemberGift,
            wineClubSignup__clubMemberSelf
        } = this.props.resources;

        const { forMyself } = this._dataStore.get();

        return (
            <div className='wine-club-signup-membership'>
                <h2 className='wine-club-signup-membership-title'>{this.props.config.chooseRecipient?.title || wineClubSignup__stepThreeMembership}</h2>
                {this.props.config.chooseRecipient?.subtitle && <RichTextComponent className='wine-club-signup-membership-subtitle' text={this.props.config.chooseRecipient.subtitle} />}
                <div className='wine-club-signup-membership-buttons'>
                    <button
                        onClick={this._onMemberTypeSelect}
                        data-member-type={MEMBER_TYPES.SELF}
                        disabled={forMyself !== null && forMyself}
                        className='wine-club-signup-membership-button-self'
                    >
                        {this.props.config.chooseRecipient?.optionSelf || wineClubSignup__clubMemberSelf}
                    </button>
                    <button
                        onClick={this._onMemberTypeSelect}
                        data-member-type={MEMBER_TYPES.GIFT}
                        disabled={forMyself !== null && !forMyself}
                        className='wine-club-signup-membership-button-gift'
                    >
                        {this.props.config.chooseRecipient?.optionGift || wineClubSignup__clubMemberGift}
                    </button>
                </div>
            </div>
        );
    }

    private _onMemberTypeSelect(event: React.MouseEvent<HTMLButtonElement>): void {
        const memberType = (event.target as HTMLButtonElement).dataset.memberType;
        const store = this._dataStore.get();

        if (parseInt(memberType || '', 10) === MEMBER_TYPES.SELF) {
            store.forMyself = true;
        }
        if (parseInt(memberType || '', 10) === MEMBER_TYPES.GIFT) {
            store.forMyself = false;
        }

        this._dataStore.edit(store);
    }
}